import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const hazardFamiliesRoutes: Routes = [
  {
    title: 'pagesTitles.hazardFamilies',
    path: APP_ROUTES.HAZARD_FAMILIES,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardCatalogRead)],
    loadComponent: () => import('./pages/hazard-families-list').then((m) => m.HazardFamiliesList),
  },
];
